import { Site } from "rivals/shared/interfaces/Site";

export type Author = {
  firstName: string;
  fullName: string;
  lastName: string;
  profileImage?: string;
  site: Pick<Site, "name" | "primaryColor" | "secondaryColor" | "siteUrl">;
  siteTitle: string;
  twitterHandle?: string;
};

export interface ArticleAuthor extends ArticleOneTimeAuthor {
  bio: string | null;
  hasEditedProfile: boolean;
  id: number;
  imageUrl: string | null;
  siteId: number;
  siteName: string;
  siteShortName: string;
  twitterHandle: string | null;
  updatedAt: string;
  userId: number;
}

export interface ArticleOneTimeAuthor {
  firstName: string;
  lastName: string;
  publisherName: string;
  publisherNameAndTitle: string;
  siteTitle: string;
}

export function isArticleAuthorType(
  author: ArticleAuthor | ArticleOneTimeAuthor
): author is ArticleAuthor {
  return (author as ArticleAuthor).id !== undefined;
}
